import { render, staticRenderFns } from "./OTVehicleDetail.vue?vue&type=template&id=dd748cb0&scoped=true&lang=pug"
import script from "./OTVehicleDetail.vue?vue&type=script&lang=js"
export * from "./OTVehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./OTVehicleDetail.vue?vue&type=style&index=0&id=dd748cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd748cb0",
  null
  
)

export default component.exports